import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import { useSessionStore } from './stores/session'
import { useBillingStore } from './stores/billing'
import './style.css'

const app = createApp(App)
app.use(createPinia())
app.use(router)
window.addEventListener('console:unauthorized', () => { useSessionStore().user = null })
window.addEventListener('console:access-denied', event => {
  const detail = (event as CustomEvent).detail
  void useBillingStore().refresh(detail.workspaceId)
})
window.addEventListener('console:platform-forbidden', () => {
  const session = useSessionStore(); session.platformDenied = true
  if (router.currentRoute.value.meta.platform) void router.replace('/app')
})
window.addEventListener('focus', () => { void useBillingStore().refresh() })
app.mount('#app')
